<template>
    <button class="secondary-button default-element-size" :class="color" :disabled="disabled">
        <slot/>
    </button>
</template>

<script>
    export default {
        name: "secondary_button",
        props: {
            color: {
                type: String,
                default: "blue"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    .secondary-button {
        position: relative;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        padding: 0 16px;
        color: $text_gray;

        &.blue {
            color: $blue;
            background-color: rgba($blue, 0.12);

            &:hover {
                background-color: rgba($blue, 0.24);
            }
        }

        &.green {
            color: $green;
            background-color: rgba($green, 0.12);

            &:hover {
                background-color: rgba($green, 0.24);
            }
        }

        &.orange {
            color: $orange;
            background-color: rgba($orange, 0.12);

            &:hover {
                background-color: rgba($orange, 0.24);
            }
        }
        &.purple {
            color: $purple;
            background-color: rgba($purple, 0.12);

            &:hover {
                background-color: rgba($purple, 0.24);
            }
        }

        &.red {
            color: $red;
            background-color: rgba($red, 0.12);

            &:hover {
                background-color: rgba($red, 0.24);
            }
        }

        &.gray {
            color: $text_gray;
            background-color: rgba($text_gray, 0.12);

            &:hover {
                background-color: rgba($text_gray, 0.24);
            }
        }

        &.none {
            background: none;
            color: $text_gray;

            &:hover {
                color: rgba($text_light_gray, 1);
            }
        }

        &:disabled{
            opacity: 0.5;
            cursor: default;
            pointer-events: none;
        }
    }
</style>